/* eslint-disable @typescript-eslint/no-explicit-any */
import getConfig from '../../../helpers/config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getPrepareHeaders } from '../get-prepare-headers';
import {
  ListPrezencaProps,
  ListePrezencaByIDProps,
  ListePrezencaParams,
} from '../../../interfaces/liste-prezenca.interface';
import { PaginationReturn } from '../../../interfaces/pagination';
import { ROLES } from '../../../constants/enums/roles';
import {
  admin,
  kancelar,
  pedagog,
  specialistFF,
  student,
} from '../../../components/common/common-functions/common-functions';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';

const { test } = getConfig();

type ListePrezenca = PaginationReturn<ListPrezencaProps>;

const getBaseUrl = (role: ROLES) => {
  if ([admin, specialistFF, kancelar].includes(role)) {
    return 'liste-prezenca';
  }
  if (role === student) {
    return 'liste-prezenca/per-student';
  }
  if (role === pedagog) {
    return 'liste-prezenca/per-pedagog';
  }
  return '';
};

export const listePrezencaApi = createApi({
  reducerPath: 'listePrezencaApi',
  tagTypes: ['OrariListePrezenca', 'ListePrezenca'],
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  endpoints: builder => ({
    getListPrezenca: builder.query<ListePrezenca, ListePrezencaParams>({
      query: ({ role, ...args }) =>
        getCommonUrl(args, getBaseUrl(role as ROLES)),
      providesTags: ['ListePrezenca'],
    }),
    getListePrezencaById: builder.query<ListePrezencaByIDProps, number>({
      query: id => ({
        url: `/liste-prezenca/${id}`,
        method: 'GET',
      }),
      providesTags: ['OrariListePrezenca'],
    }),
    createListpezenca: builder.mutation<any, any>({
      query: ({ id, postData }) => ({
        url: `/liste-prezenca/${id}/klasa-student`,
        method: 'PUT',
        body: postData,
      }),
      invalidatesTags: ['OrariListePrezenca', 'ListePrezenca'],
    }),
  }),
});

export const {
  useGetListPrezencaQuery,
  useGetListePrezencaByIdQuery,
  useCreateListpezencaMutation,
} = listePrezencaApi;
